// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Exam_Loading__2IQ2o","Error":"Exam_Error__ei1F_"};